import { jsx, jsxs } from "react/jsx-runtime";
import { DiscGroup, Divider, IconToggleButton, cn } from "@pcln/horizon";
import { recentSelectionVariants } from "../../RecentSelection.variants.js";
import { CTAButtons, DateBlock, OccupancySection } from "../../common/shared.js";
function PackageSelection({ buttonText = 'Book Now', checkIn, checkOut, className, headline, isFavorite, locationText, occupancyText, onClick, onFavoriteToggle, productTypes, subtitle: subtitleText }) {
    const resolvedSubtitle = subtitleText ?? locationText ?? '';
    const { attributeRow, bottomSection, card, contentWrapper, dateBlockDividerHorizontal, dateBlockDividerVertical, dateBlocksContainer, favoriteButton, imageContainer, infoSection, middleSection, root, subtitle, title, topSection } = recentSelectionVariants({
        productType: 'packages'
    });
    const contentData = productTypes.map((type)=>({
            content: type,
            contentType: 'icon',
            emphasis: 'medium',
            palette: 'marketingBrand'
        }));
    return /*#__PURE__*/ jsx("div", {
        className: cn(root(), className),
        children: /*#__PURE__*/ jsx("div", {
            className: card(),
            onClick: onClick,
            children: /*#__PURE__*/ jsxs("div", {
                className: contentWrapper(),
                children: [
                    /*#__PURE__*/ jsxs("div", {
                        className: topSection(),
                        children: [
                            onFavoriteToggle && /*#__PURE__*/ jsx("div", {
                                className: favoriteButton(),
                                children: /*#__PURE__*/ jsx(IconToggleButton, {
                                    ariaLabel: "Favorite this package",
                                    emphasis: "bold",
                                    isAnimated: true,
                                    isToggledOn: isFavorite,
                                    onToggle: onFavoriteToggle,
                                    palette: "favorite",
                                    size: "24"
                                })
                            }),
                            /*#__PURE__*/ jsxs("div", {
                                className: cn(imageContainer(), 'flex items-center justify-center rounded-xl'),
                                children: [
                                    /*#__PURE__*/ jsx("div", {
                                        className: "@3xl:hidden",
                                        children: /*#__PURE__*/ jsx(DiscGroup, {
                                            alt: "Package products",
                                            contentData: contentData,
                                            size: "xs"
                                        })
                                    }),
                                    /*#__PURE__*/ jsx("div", {
                                        className: "hidden @3xl:block @5xl:hidden",
                                        children: /*#__PURE__*/ jsx(DiscGroup, {
                                            alt: "Package products",
                                            contentData: contentData,
                                            size: "sm"
                                        })
                                    }),
                                    /*#__PURE__*/ jsx("div", {
                                        className: "hidden @5xl:block",
                                        children: /*#__PURE__*/ jsx(DiscGroup, {
                                            alt: "Package products",
                                            contentData: contentData,
                                            size: "md"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ jsxs("div", {
                                className: infoSection(),
                                children: [
                                    /*#__PURE__*/ jsx("div", {
                                        className: title(),
                                        children: headline
                                    }),
                                    resolvedSubtitle && /*#__PURE__*/ jsx("div", {
                                        className: attributeRow(),
                                        children: /*#__PURE__*/ jsx("div", {
                                            className: subtitle(),
                                            children: resolvedSubtitle
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("div", {
                        className: middleSection(),
                        children: [
                            /*#__PURE__*/ jsxs("div", {
                                className: dateBlocksContainer(),
                                children: [
                                    /*#__PURE__*/ jsx(DateBlock, {
                                        dateInfo: checkIn,
                                        label: "Check-in",
                                        productType: "packages"
                                    }),
                                    /*#__PURE__*/ jsx(Divider, {
                                        className: dateBlockDividerVertical(),
                                        direction: "vertical"
                                    }),
                                    /*#__PURE__*/ jsx(Divider, {
                                        className: dateBlockDividerHorizontal(),
                                        direction: "horizontal"
                                    }),
                                    /*#__PURE__*/ jsx(DateBlock, {
                                        dateInfo: checkOut,
                                        label: "Check-out",
                                        productType: "packages"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ jsxs("div", {
                                className: bottomSection(),
                                children: [
                                    /*#__PURE__*/ jsx(OccupancySection, {
                                        iconName: "person",
                                        text: occupancyText
                                    }),
                                    /*#__PURE__*/ jsx(CTAButtons, {
                                        buttonText: buttonText,
                                        onClick: onClick
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
export { PackageSelection };
